module.exports = __webpack_public_path__ + "img/tpt.2ad3554f.png";